import React, { useMemo } from 'react';
import { useCampaigns } from '@domain/campaigns/campaigns.hooks';
import { MultiSelect } from '@paretogroup/tess';
import { CAMPAIGNS_SELECTOR, TEST_IDS } from './campaigns-selector.constants';
import { useStyles } from './campaigns-selector.styles';
import { getTagLabel } from './campaigns-selector.utils';
import { FILTER_DRAWER_OPERATIONS_TEXTS } from '../../filter-drawer-operations.constants';

interface CampaignSelectorProps {
    onChange: (value) => void;
    isDisabled: boolean;
}

export const CampaignSelector = ({ onChange, isDisabled }:CampaignSelectorProps) => {
    const { campaigns } = useCampaigns();
    const classes = useStyles();

    const options = useMemo(() => Object.values(campaigns.data)
        .map(campaign => ({
            value: campaign.campaign_id,
            label: campaign.name,
        })), [campaigns.data]);

    const renderTags = (tags) => {
        const tagLabel = getTagLabel(tags);
        return <div className={classes.tagLabel}>{tagLabel}</div>;
    };

    return (
        <MultiSelect
            label={FILTER_DRAWER_OPERATIONS_TEXTS.VALUE}
            options={options}
            placeholder={CAMPAIGNS_SELECTOR.PLACEHOLDER}
            onChange={(_, value) => onChange(value)}
            disabled={isDisabled}
            renderTags={renderTags}
            optionComponentProps={{
                'data-auto-testid': TEST_IDS.valueCampaignsOption,
            }}
        />
    );
};
